/**
 * @author WestLangley / http://github.com/WestLangley
 *
 */


import { LineSegments2 } from "./LineSegments2.js";
import { LineGeometry } from "./LineGeometry.js";
import { LineMaterial } from "./LineMaterial.js";

class Line2 extends LineSegments2 {

	constructor(geometry, material) {

		super(geometry, material);

		this.type = 'Line2';

		this.geometry = geometry !== undefined ? geometry : new LineGeometry();
		this.material = material !== undefined ? material : new LineMaterial({ color: Math.random() * 0xffffff });

	}

	get isLine2() { return true; }

}

export { Line2 };
